export default {
    getHeaderFieldsEprofileNemAllergia: state => state.headerFieldsEprofileNemAllergia,
    getFormActionsEprofileNemAllergia: state => state.formActionsEprofileNemAllergia,
    getActionsEprofileNemAllergia: state => state.actionsEprofileNemAllergia,
    getRowActionsEprofileNemAllergia: state => state.rowActionsEprofileNemAllergia,
    getSearchFields: state => state.searchFields,
    isFormOpenEprofileNemAllergia: state => state.formIsOpen,
    isGridOpenEprofileNemAllergia: state => state.gridIsOpen
}
